(() => {
  if (window.RoborockHeaderLayout) return;
  const root = document.documentElement;
  let frame = 0, trackUntil = 0, offset = -1, headers = [];
  const visible = element => {
    const style = getComputedStyle(element);
    return style.display !== 'none' && style.visibility !== 'hidden' && Number(style.opacity) !== 0 && element.getClientRects().length > 0;
  };
  const measure = () => {
    frame = 0;
    let bottom = 0;
    for (const header of headers) {
      if (!visible(header)) continue;
      bottom = Math.max(bottom, header.getBoundingClientRect().bottom);
      // On desktop the nav row is absolutely positioned below the utility row.
      // Its dropdown is an overlay and deliberately does not increase the offset.
      for (const row of header.querySelectorAll('.rr-main-row')) {
        if (row.inert || row.closest('.is-navigation-hidden') || !visible(row)) continue;
        bottom = Math.max(bottom, row.getBoundingClientRect().bottom);
      }
    }
    const next = Math.ceil(Math.max(0, Math.min(innerHeight, bottom)));
    if (next !== offset) {
      offset = next;
      root.style.setProperty('--rr-header-offset', `${next}px`);
      document.dispatchEvent(new CustomEvent('roborock:header-layout', {detail: {offset: next}}));
    }
    if (performance.now() < trackUntil) refresh();
  };
  const refresh = () => {if (!frame) frame = requestAnimationFrame(measure);};
  const resize = new ResizeObserver(refresh);
  const changes = new MutationObserver(refresh);
  const bind = () => {
    resize.disconnect();changes.disconnect();
    headers = [...document.querySelectorAll('.section-header')];
    if (!headers.length) headers = [...document.querySelectorAll('sticky-header')];
    for (const header of headers) {
      resize.observe(header);
      header.querySelectorAll('.rr-main-row,.rr-utility-row').forEach(row => resize.observe(row));
      changes.observe(header, {subtree:true,childList:true,attributes:true,attributeFilter:['class','style','open','hidden','inert']});
    }
    refresh();
  };
  window.RoborockHeaderLayout = {refresh, get offset() {return Math.max(0, offset);}};
  window.addEventListener('scroll', refresh, {passive:true});
  window.addEventListener('resize', refresh, {passive:true});
  window.addEventListener('pageshow', refresh);
  document.addEventListener('transitionrun', event => {
    if (!event.target.closest('.section-header')) return;
    trackUntil = performance.now() + 350;refresh();
  });
  document.addEventListener('transitionend', refresh);
  document.addEventListener('shopify:section:load', bind);
  document.addEventListener('shopify:section:unload', () => requestAnimationFrame(bind));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind, {once:true});else bind();
  document.fonts?.ready.then(refresh);
})();
